import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './components/LanguageContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import DestinationsPage from './pages/DestinationsPage';
import DestinationDetailPage from './pages/DestinationDetailPage';
import AllHotelsPage from './pages/AllHotelsPage';
import HotelDetailPage from './pages/HotelDetailPage';
import AboutPage from './pages/AboutPage';
import PricesPage from './pages/PricesPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import GdprPage from './pages/GdprPage';
import ConsentPage from './pages/ConsentPage';
import RequestQuotePage from './pages/RequestQuotePage';
import GalleryPage from './pages/GalleryPage';
import PraktiskInformationPage from './pages/PraktiskInformationPage';
import TourSuggestionsPage from './pages/TourSuggestionsPage';
import RejsetipsPage from './pages/RejsetipsPage';
import RejsetipsGuidePage from './pages/RejsetipsGuidePage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <LanguageProvider>
      <Layout>
        <ScrollToTop />
        <Routes>
          {/* Danish Routes */}
          <Route path="/da" element={<Home />} />
          <Route path="/da/handicapvenlige-ferie-destinationer" element={<DestinationsPage />} />
          <Route path="/da/handicapvenlige-hoteller" element={<AllHotelsPage />} />
          <Route path="/da/destination/:id" element={<DestinationDetailPage />} />
          <Route path="/da/hotel/:hotelId" element={<HotelDetailPage />} />
          <Route path="/da/hotel/:hotelId/turforslag" element={<TourSuggestionsPage />} />
          <Route path="/da/destination/:id/turforslag" element={<TourSuggestionsPage />} />
          <Route path="/da/om-mig" element={<AboutPage />} />
          <Route path="/da/priser" element={<PricesPage />} />
          <Route path="/da/kontakt" element={<ContactPage />} />
          <Route path="/da/rejsebetingelser" element={<TermsPage />} />
          <Route path="/da/gdpr" element={<GdprPage />} />
          <Route path="/da/samtykke" element={<ConsentPage />} />
          <Route path="/da/tilbud" element={<RequestQuotePage />} />
          <Route path="/da/rejsetips" element={<RejsetipsPage />} />
          <Route path="/da/rejsetips/hvad-skal-du-huske-paa-ferie-som-koerestolsbruger" element={<RejsetipsGuidePage />} />
          <Route path="/da/galleri-oversigt" element={<GalleryPage />} />
          <Route path="/da/praktisk-information" element={<PraktiskInformationPage />} />

          {/* English Routes */}
          <Route path="/en" element={<Home />} />
          <Route path="/en/accessible-holiday-destinations" element={<DestinationsPage />} />
          <Route path="/en/accessible-hotels" element={<AllHotelsPage />} />
          <Route path="/en/destination/:id" element={<DestinationDetailPage />} />
          <Route path="/en/hotel/:hotelId" element={<HotelDetailPage />} />
          <Route path="/en/hotel/:hotelId/tour-suggestions" element={<TourSuggestionsPage />} />
          <Route path="/en/destination/:id/tour-suggestions" element={<TourSuggestionsPage />} />
          <Route path="/en/about-me" element={<AboutPage />} />
          <Route path="/en/prices" element={<PricesPage />} />
          <Route path="/en/contact" element={<ContactPage />} />
          <Route path="/en/terms-and-conditions" element={<TermsPage />} />
          <Route path="/en/gdpr" element={<GdprPage />} />
          <Route path="/en/consent" element={<ConsentPage />} />
          <Route path="/en/request-quote" element={<RequestQuotePage />} />
          <Route path="/en/travel-tips" element={<RejsetipsPage />} />
          <Route path="/en/travel-tips/what-to-remember-on-holiday-as-a-wheelchair-user" element={<RejsetipsGuidePage />} />
          <Route path="/en/gallery" element={<GalleryPage />} />
          <Route path="/en/practical-information" element={<PraktiskInformationPage />} />

          {/* Fallback for other paths is handled dynamically by LanguageProvider, but we keep Navigate as a safety net */}
          <Route path="*" element={<Navigate to="/da" replace />} />
        </Routes>
      </Layout>
    </LanguageProvider>
  );
}

export default App;
